export default __webpack_public_path__ + "static/media/Sandwich-Panels-Fineagles-Methods.6d7b2a41.jpg";